import React from "react";

const FormField = (props) => {
  return (
    <div className="mb-3">
      <label for="recipient-name" className="col-form-label">
        {props.label}
      </label>
      <input
        type={props.type}
        className="form-control "
        id="recipient-name"
        placeholder={props.placeholder}
        defaultValue={props.defaultValue}
        name={props.name}
        required
      />
    </div>
  );
};

export default FormField;
